/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useGetNotesFileSystemInvalidator } from './use-get-notes-file-system';

/**
 * `Payload` type.
 */

type Payload = {
  id: string | React.Key;
  name: string;
  content: string | null;
  favorite: boolean;
};

/**
 * Post edit item.
 */

async function postEditItem(
  client: AxiosInstance,
  id: string | React.Key | undefined,
  name: string | undefined,
  content: string | null | undefined,
  favorite: boolean | undefined
): Promise<void> {
  return await client({
    method: 'patch',
    data: {
      content,
      favorite,
      id,
      name
    },
    url: resolveAppUrl('appsNotes')
  });
}

/**
 * Export `usePostNotesEditItem`.
 */

export function usePostNotesEditItem() {
  const client = useRequestProvider();
  const invalidator = useGetNotesFileSystemInvalidator();

  return useMutation({
    mutationFn: async ({ name, id, content, favorite }: Partial<Payload>) => {
      const result = await postEditItem(client, id, name, content, favorite);

      await invalidator();

      return result;
    },
    onSuccess: () => {
      // Nothing todo.
    }
  });
}
